export default {
  "shoes": "Buty",
  "hoodies": "Bluzy/Swetry",
  "tshirts": "Koszulki",
  "jackets": "Kurtki",
  "pants": "Spodnie/Szorty",
  "headwear": "Nakrycia głowy",
  "sets": "Zestawy",
  "underwear": "Bielizna",
  "jersey": "Koszulki sportowe",
  "accessories": "Akcesoria",
  "bags": "Torby",
  "belts": "Paski",
  "perfumes": "Perfumy",
  "other": "Inne rzeczy",
  "view": "Zobacz",
  "tag.shoes": "Obuwie",
  "tag.hoodies": "Góra",
  "tag.tshirts": "Góra",
  "tag.jackets": "Odzież wierzchnia",
  "tag.pants": "Dół",
  "tag.headwear": "Akcesoria",
  "tag.sets": "Zestawy",
  "tag.underwear": "Bielizna",
  "tag.jersey": "Sport",
  "tag.accessories": "Dodatki",
  "tag.bags": "Torby",
  "tag.belts": "Akcesoria",
  "tag.perfumes": "Zapachy",
  "tag.other": "Więcej"
};